import { EditorJs } from "src";
import { EditorBlock } from "src/types/blocks";
import { TextReturnTypes } from "src/types/editorjs";

type EditorJSParserOptions = {
	includeHeadings?: number[];
};

export default class EditorJSParser {
	static getBlocksFromEditor(editorBlock: EditorBlock) {
		return JSON.parse(editorBlock.editor as string) as EditorJs.Editor;
	}
	static getTextBlocks(editorBlock: EditorBlock) {
		const editor = this.getBlocksFromEditor(editorBlock);
		return editor.blocks.filter((block) => {
			const textBlockTypes = ["header", "paragraph", "list", "checklist"];
			return textBlockTypes.includes(block.type);
		}) as TextReturnTypes[];
	}
	static getHeaderBlocks(
		editorBlock: EditorBlock,
		options: EditorJSParserOptions = {},
	) {
		const { includeHeadings = [2, 3, 4] } = options;
		const editor = this.getBlocksFromEditor(editorBlock);
		if (!editor.blocks) return [];
		return editor.blocks.filter((block) => {
			return (
				block.type === "header" && includeHeadings.includes(block.data.level)
			);
		}) as EditorJs.Header[];
	}
}
